export enum SignUpErrorCode {
  UserExists = 'user_exists',
  InvalidPassword = 'invalid_password',
}
